import ProfileAbout from '@/screens/ProfileAbout';

export default function PrivateProfileAboutRoute() {
  return <ProfileAbout />;
}
